import _ from 'lodash'
const ACTUALITY_GRID_CONFIG = {
    section: _.select( '.c-section--actuality-grid' ),
    grid: _.select( '.c-section--actuality-grid .grid' ),
    filters: _.selectAll( '.c-section--actuality-grid .filters input' )
}

export default ACTUALITY_GRID_CONFIG